import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { buildCanonicalUrl } from "lib/seo";

import type { TalksPageData } from "content-ui/talks/types";

import { fetchTalksPageData } from "content-ui/talks/fetcher";
import { fetchNavbarAndFooter } from "lib/fetchers/common";

import TalksView from "content-ui/talks";
import PreviewModeBanner from "components/previewModeBanner/previewModeBanner";
import ErrorBoundary from "components/errorBoundary/errorBoundary";
import Navigation from "components/navigation/navigation";
import Footer from "components/footer/footer";

export async function getServerSideProps({ res, preview = false }) {
  const [menuItems, dato] = await Promise.all([
    fetchNavbarAndFooter(),
    fetchTalksPageData({ preview }),
  ]);

  res.setHeader(
    "Cache-Control",
    "public, s-maxage=10, stale-while-revalidate=59"
  );

  return {
    props: {
      dato,
      previewMode: preview,
      __initialState: {
        sitewideOption: { ...menuItems },
      },
    },
  };
}

type PageProps = {
  dato: TalksPageData;
  previewMode: boolean;
};

const TalksPage = (props: PageProps) => {
  const title = props.dato?.seo?.title || "";
  const description = props.dato?.seo?.description || "";
  const seoImage = props.dato?.seo?.image?.url || "";

  return (
    <>
      <Head>
        {generateNextSeo({
          canonical: buildCanonicalUrl("/talks"),
          openGraph: {
            title: title,
            description: description,
            images: [{ url: seoImage }],
          },
          twitter: {
            handle: "@siftedeu",
            site: "@siftedeu",
            cardType: "summary_large_image",
          },
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Navigation />

      {props.previewMode ? <PreviewModeBanner exitSlug={`/talks`} /> : null}

      <ErrorBoundary>
        <TalksView data={props.dato} />
      </ErrorBoundary>

      <Footer />
    </>
  );
};

export default TalksPage;
